import React, { useState } from 'react'
import styled from 'styled-components'
import { FormLabel } from '../FormLabel'

const isMobile = window.innerWidth < 712

const StyledTag = styled.button<{ isSelected: boolean }>`
  border: 0;
  background-color: ${({ isSelected }) =>
    isSelected ? 'var(--brandblue-bright-5)' : 'white'};
  color: ${({ isSelected }) =>
    isSelected ? 'var(--brandblue-main)' : 'var(--brandblue-bright-3)'};
  border: ${({ isSelected }) =>
    isSelected
      ? '1px solid var(--beige-bright-3)'
      : '1px solid var(--beige-bright-1)'};

  position: relative;
  font-family: var(--font-plex);
  border-radius: 4px;
  padding: 8px;
  padding-left: 15px;
  padding-right: 45px;
  font-size: 15px;
  display: inline-block;
  text-align: left;
  min-width: 24%;

  &:hover {
    cursor: pointer;
    background-color: var(--brandblue-bright-4);
    color: var(--brandblue-main);
  }
  &:after {
    content: '';
    position: absolute;
    right: 15px;
    top: calc(50% - 8px);
    display: ${({ isSelected }) => (isSelected ? 'inline-block' : 'none')};
    width: 6px;
    height: 12px;
    border-right: 2.5px solid var(--brandblue-main);
    border-bottom: 2.5px solid var(--brandblue-main);
    transform: rotate(45deg);
  }
`
const Entries = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
`
export const MultiSelect = ({
  entries,
  label,
  current,
  id,
  change
}: {
  label: string
  id: string
  current: string[]
  entries: { label: string; value: number; id: string }[]
  change: (e) => void
}) => {
  const allIds = entries.map(m => m.id)
  const [selected, setSelected] = useState<string[]>(
    current[0] === 'all' ? allIds : current
  )

  const handleChange = (newid: string) => {
    if (!selected.includes(newid)) {
      change({ filterid: id, propid: [...selected, newid] })
      setSelected([...selected, newid])
      return
    }
    const indexOfnewId = selected.findIndex(f => f === newid)
    const sel = [...selected]
    sel.splice(indexOfnewId, 1)
    change({ filterid: id, propid: sel })
    setSelected(sel)
  }

  return (
    <div className='SelectWrapper'>
      <FormLabel>{label}</FormLabel>
      <Entries>
        {entries.map((m, i) => (
          <StyledTag
            key={'Key_MultiSelect_' + i}
            isSelected={selected.includes(m.id)}
            onClick={() => handleChange(m.id)}
          >
            {m.label}
          </StyledTag>
        ))}
      </Entries>
    </div>
  )
}
